import Pusher from 'pusher-js';

function subscriber(app){
    const pusher = new Pusher(process.env.MIX_PUSHER_APP_KEY, {
        cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        encrypted: true,
        authEndpoint: '/broadcasting/auth',
        auth: {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
            }
        }
    });
    const userId = window?.Laravel?.userId;
    const channel = pusher.subscribe(`private-notification.user.${userId}`);
    app.config.globalProperties.$pusher = pusher;
    app.config.globalProperties.$channel = channel;
}

export default {
    install(app) {
        subscriber(app);
    }
};
